import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { MdrMandatoryContactInformation } from '../../../../company/types/company-data';
import { GetItemsRequest, GetItemsResponse } from '../../types';

export class AccountsForMdrContactDataProvider extends GzSingleSelectComplexBaseDataProvider {
  private readonly cachedList: { [key: string]: MdrMandatoryContactInformation } = {};

  private _editedCompanyId?: string;

  async getItems({ searchValue, page, limit }: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Users',
        method: 'getAccountsForMdrContact',
        payload: {
          page,
          limit,
          filter: {
            targetOrParentId: this._editedCompanyId,
            name: searchValue,
          },
        },
      });

      const items = this.pushItemsToCacheAndReturnThem(response.data);

      return {
        items,
        totalItemsCount: response.total, // won't bother calculating the true total as it's too intensive
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Users',
        method: 'getAccountsForMdrContact',
        payload: {
          page: request.page,
          limit: request.limit,
          filter: {
            targetOrParentId: this._editedCompanyId,
          },
        },
      });

      const items = this.pushItemsToCacheAndReturnThem(response.data);

      return {
        items,
        totalItemsCount: response.total, // won't bother calculating the true total as it's too intensive
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  public getCachedAccount(accountId: string): MdrMandatoryContactInformation {
    return this.cachedList[accountId];
  }

  public set editedCompanyId(value: string | undefined) {
    this._editedCompanyId = value;
  }

  private pushItemsToCacheAndReturnThem(data: any[]): { value: string; label: string }[] {
    const items: { value: string; label: string; parent: string }[] = [];

    data.forEach(account => {
      this.cachedList[account._id] = {
        fullName: account.profile.fullName,
        email: account.email,
        phoneNumber: account.phoneNumber,
        hasVerifiedEmail: account.hasVerifiedEmail,
        parent: account.company.name,
      };

      items.push({ value: account._id, label: account.profile.fullName, parent: account.company.name });
    });

    return items;
  }
}
